import styled from "styled-components";
import { Link } from "react-router-dom";

export const RowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Title = styled.h1`
	font-size: 20px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const MainLink = styled(Link)`
	background: #504c9a;
	border: 1px solid #504c9a;
	padding: 8px 48px;
	color: #fff;
	font-size: 16px;
	line-height: 23px;
	font-weight: bold;
	border-radius: 8px;

	&:hover {
		color: #fff;
	}
`;

export const FiltersContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 32px;
`;

export const FilterTitle = styled.h2`
	font-size: 16px;
	font-weight: bold;
	color: #000 !important;
`;

export const InputsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-direction: column;

	label {
		font-size: 14px;
		color: #31475a;
		margin-bottom: 0;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 12px;
	width: 100%;

	button:first-child {
		background: transparent;
		border: 1px solid #504c9a;
		padding: 8px 48px;
		color: #504c9a;
		font-size: 16px;
		line-height: 23px;
		font-weight: bold;
		border-radius: 8px;
	}

	button:last-child {
		background: #504c9a;
		border: 1px solid #504c9a;
		padding: 8px 48px;
		color: #fff;
		font-size: 16px;
		line-height: 23px;
		font-weight: bold;
		border-radius: 8px;
	}
`;

export const DateRangePickerContainer = styled.div`
	border: 1px solid #31475a;
	padding: 3px;
	border-radius: 5px;

	&:hover {
		border: 1px solid #000;
	}
`;

export const TableContainer = styled.div`
	margin-top: 32px;
`;

export const StatusBadge = styled.div`
	background-color: ${props => props.variant};
	border-radius: 8px;
	padding: 8px 12px;
	width: 105px;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		color: #fff;
		font-size: 14px;
		text-align: center;
	}
`;

export const PriorityBadge = styled.div`
	background-color: ${props => props.variant};
	border-radius: 8px;
	padding: 8px 12px;
	width: 105px;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		color: #fff;
		font-size: 14px;
		text-align: center;
	}
`;
